import { render, staticRenderFns } from "./MetaInfoEdit.vue?vue&type=template&id=b83a09b6&scoped=true"
import script from "./MetaInfoEdit.vue?vue&type=script&lang=js"
export * from "./MetaInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83a09b6",
  null
  
)

export default component.exports